import { render, staticRenderFns } from "./ParkingPushRecord.vue?vue&type=template&id=70b5bce4&"
import script from "./ParkingPushRecord.vue?vue&type=script&lang=js&"
export * from "./ParkingPushRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports